import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isRemoveDiscussionRequestFailure({ uuid }) {
      const req = getState().find(({ discussion }) => discussion.uuid === uuid);

      return req ? req.request.isFailure : false;
    },
    isRemoveDiscussionRequestPending({ uuid }) {
      const req = getState().find(({ discussion }) => discussion.uuid === uuid);

      return req ? req.request.isPending : false;
    },
    isRemoveDiscussionRequestSuccess({ uuid }) {
      const req = getState().find(({ discussion }) => discussion.uuid === uuid);

      return req ? req.request.isSuccessful : false;
    },
  };
}

export { createSelector };
